const REMEMBER_ME_KEY = "rememberMe";
const USERNAME_KEY = "username";

export const readRememberMePreference = (): boolean => localStorage.getItem(REMEMBER_ME_KEY) === "true";

export const readSavedUsername = (): string => {
  if (!readRememberMePreference()) {
    return "";
  }
  return localStorage.getItem(USERNAME_KEY) || "";
};

export const persistRememberMePreference = (rememberMe: boolean, username: string): void => {
  if (rememberMe) {
    localStorage.setItem(REMEMBER_ME_KEY, "true");
    localStorage.setItem(USERNAME_KEY, username);
  } else {
    localStorage.removeItem(REMEMBER_ME_KEY);
    localStorage.removeItem(USERNAME_KEY);
    localStorage.removeItem("password");
  }
};
